import ReactSwitch from "react-switch";
import styled from "styled-components";

const StyledSwitch = styled.label`
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #373647;

    .react-switch-bg {
        background: ${({ checked }) => checked ? 'linear-gradient(270deg, #8468FF 0%, #6D8EFF 100%) !important' : '#888'}
    }
`

const Switch = ({ onChange, checked, disabled, height=21, width=42, label, className }) => {
    return (
        <StyledSwitch checked={checked} className={className}>
            <ReactSwitch 
                onChange={onChange} 
                checked={checked} 
                disabled={disabled}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor="#6D8EFF"
                height={height}
                width={width}
                activeBoxShadow="none"
            />
            <span>{label}</span>
        </StyledSwitch>
    );
};

export default Switch;